<template>
<div class="component">
    <div class="highscoreData">
  
        <div class="highscoreList">
            <div v-for="(userData, place) in highscoreData" :class="{'ownHighscoreListRow': userData.id == $store.getters.getUser.id}" class="columns is-mobile is-multiline has-text-left highscoreListRow is-gapless">
                <div class="highscoreListPlace column is-1 has-text-left" v-if="place==0">
                    <span class="firstPlace">1 <i class="fas fa-trophy"></i></span>
                </div>
                <div v-else class="highscoreListPlace column is-1 has-text-left">{{1+place}}</div>

                <div class="highscoreListProfileImage column is-2"> <img class="profileThumbnail" :src="$storageURL+'/avatars/'+userData.avatar">
                </div>

                <div class="column is-6 highscoreListUsername has-text-centered">{{userData.nickname}}</div>
                <div class="column is-3 highscoreListPoints">{{userData.score}} <i class="fas fa-leaf"></i></div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    // <img class="profileThumbnail" :src="this.$storageURL+'/avatars/'+this.avatar">
    name: 'highscore',
    props: [],
    mounted: function () {
        this.getHighscoreList();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            highscoreData: []
        }
    },
    methods: {
        getHighscoreList() {
            this.callApi("/user/highscore").then(function (result) {
                this.highscoreData = result.data.user
            }.bind(this))
        },
        getHighscoreRank(place) {
            place += 1;

            if (place == 1) {
                return '<span class="firstPlace">1 <i class="fas fa-trophy"></i></span>'
            } else {
                return '<span>' + place + '</span>'
            }
        }
    },
    computed: {},
}
</script>

<style scoped>
.firstPlace i {
    color: gold;
}
.profileThumbnail{max-height: 3em; border-radius: 20px;margin-top:0.5em;}
.highscoreList{border: 1px solid rgba(234, 172, 0, .6);padding: 20px;}
.highscoreListPlace, .highscoreListUsername, .highscoreListPoints{line-height: 4em; font-weight:bolder;}
.component .highscoreList .highscoreListPlace{padding-left: 20px!important;}
.highscoreListRow{border-bottom: 1px solid #f5f5f5;}

.ownHighscoreListRow{background:#f5f5f5}
</style>
